<template>
<div class="footer" v-if="!$route.meta.hideFooter">
  <div class="footer-wrapper">
    <p>&copy; Beweegbuddy, Sport Vlaanderen, MOEV</p>
  </div>
</div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: $primary-blue;


  .footer-wrapper {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}


p {
  font-style: italic;
  color: $font-light;
  margin-bottom: 0;

}
</style>